export default String.raw`
.customer-profile-menu-js .active-js {
  fill: $iconColors;
  color: $iconColors;
}

.customer-container {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  padding-bottom: 24px;

  .customer-submenu {
    position: relative;
    width: 100%;
    
    &__header {
      @include h2-headline;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 24px;
      gap: 16px;
      
      .title span {
        margin-left: 4px;
      }
    }
  }

  .invoice {
    display: flex;
    gap: 8px;
  }

  .change-container {
    margin-bottom: 24px;
    text-align: left !important;
    position: relative;
  }
  
  .change-container__type {
    display: inline-block;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: $primaryColorFont;
    padding-bottom: 2px;
  }
  
  .change-type-js {
    display: inline-block;
    padding: 0 8px;
    position: relative;
  }
  
  .change-type-js.active {
    color: $iconColors;
  }
  
  .slider {
    position: absolute;
    bottom: 0;
    height: 2px;
    background-color: $iconColors;
    transition: left 0.25s, width 0.25s;
  }

  .customer-info {
    box-shadow: 0px 2px 8px 0px #0000001f;
    padding: 24px;
    margin-bottom: 32px;

    &__header,
    &__title {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      margin-bottom: 24px;
      gap: 32px;
      word-break: break-word;

      .pure-button {
        word-break: normal;
      }
    }

    &__container {
      display: flex;
      gap: 24px;
      flex-wrap: wrap;
    }

    &__content {
      display: flex;
      flex-direction: column;
      min-width: 210px;
      margin-right: 24px;

      .title {
        padding-bottom: 8px;
        display: block;
        @include body-1-regular;
        color: $labelsColor;
      }

      input:disabled,
      span {
        @include body-1-medium;
        background-color: transparent;
        border: none;
      }
    }
  }

  .customer-history {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;

    &__header,
    &__row {
      display: flex;
      gap: 24px;
      justify-content: flex-start;
      align-items: center;
      height: 40px;
      border-bottom: 1px solid #f2f2f2;
    }

    &__header {
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
    }

    &__rowData {
      display: flex;
      align-items: center;
      text-align: left;

      &--title {
        padding-left: 8px;
        min-width: 70px;
        margin-right: 12px;
        flex-basis: 85px;
      }

      &--action {
        padding-left: 8px;
        flex-basis: 350px;
      }
    }
  }

  .pagination-right {
    text-align: right;
  }

  .inc {
    width: 600px !important;
  }

  .change-data-container {
    position: relative;
    max-width: 100%;
    width: 500px;
    margin: 0 auto;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0px 0px 4px 0px $dropContainerShadowColor;
    background-color: $bgColor;
    color: $primaryColorFont;
    transform: translateY(-50%);
    top: 50%;
    left: 0px;
    right: 0px;

    .data-form {
      &__header {
        display: flex;
        justify-content: space-between;
        color: $primaryColorFont;
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        margin-bottom: 24px;
        gap: 16px;
      }

      &__info {
        border-bottom: 1px solid #E7E7E7;
        margin-bottom: 24px;
        padding-bottom: 32px;
      }
      .primary-action-button {
        width: 100%;
      }
    }
    .buttons-container {
      padding: 0;
    }

    .customer-data-edit-popup {
      max-height: 600px;
      overflow: auto;
      padding: 12px 12px 0 0;
    }
  }

  .complaint {
    text-wrap: auto;
    text-align: left;
  }

  .order-cancel {
    width: 640px;
  }

  &.not-authenticated {
    display: block;
    width: 100%;
  }
}

.buttons-container {
  padding-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.short {
  .primary-action-button {
    width: fit-content !important;
  }
}

.secondary-action-button {
  float: right;
  position: relative;
  z-index: 2;
}

.customer-edit-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__change {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 24px;

    .form__input-value-disabled {
      flex: 1;
      margin-right: 1rem;
      color: $primaryColorFont;
    }

    .secondary-action-button {
      align-self: flex-end;
      position: relative;
      bottom: 35px;
    }
  }

  label {
    margin: 0 0 5px 2px;
  }
}

.eshop {
  &__table-container {
    overflow: auto; 
    width: 100%;
    white-space: nowrap;
    position: relative;
    min-height: 40px;

    table {
      border-collapse: collapse;
      width: 100%;
    }

    thead {
      tr {
        background: white;
        position: sticky;
        z-index: 4;
        top: 0;

        &:focus-visible{
          outline-offset: -2px;
        }

        &::after {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 1px;
          background: #D5D5D5;
          z-index: 4;
        }
      }
    }

    th, td {
      padding: 8px 16px 8px 0;
      vertical-align: middle;
      text-align: left;

      &:last-child {
        padding-right: 0;
      }

      .options {
        text-align: right;
        width: 24px;
      }
    }
    
    th {
      white-space: nowrap;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
    }

    tbody {
      tr {
        border-bottom: 1px solid #D5D5D5;

        &:focus-visible {
          outline-offset: -2px !important;
        }
      }

      td {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;

        .products-list__quick-shopping-view-product {
          flex-direction: row;
        }
      }

      .prices {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      
      .summary-row {
        background: white;
        position: sticky;
        z-index: 3;
        bottom: -1px;

        &::before {
          content: "";
          position: absolute;
          top: -1px;
          left: 0;
          width: 100%;
          height: 1px;
          background: #D5D5D5;
          z-index: 4;
        }
      }
    }

    thead tr th.open-complaint-form-container-js {
      position: sticky;
      right: 0;
      background: transparent;
      z-index: 5;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        width: 200px;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 50%);
        pointer-events: none;
      }
    }

    td.complaint-actions-inline {
      white-space: nowrap;
      text-align: right;
      padding-left: 16px;
      padding-right: 8px;
      position: sticky;
      right: 0;
      background: #fff;
      z-index: 2;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: -32px;
        width: 32px;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 100%);
        pointer-events: none;
      }

      .pure-button.complaint-action-btn {
        display: inline-flex;
        background: transparent;
        border: 0;
        border-radius: 4px;
        color: $primaryColor;
        padding: 4px 8px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        transition: background-color 150ms ease;

        &:hover,
        &:focus-visible {
          color: $primaryColor;
          background: rgba(0, 0, 0, 0.06);
        }

        & + .complaint-action-btn {
          margin-left: 8px;
        }
      }
    }
  }
}

.drop {
  width: 40px;
  padding-right: 16px !important;
}

.products {
  max-height: max-content;
  min-height: 180px;
}

.row {
  &:hover,
  &:focus-within,
  &.hovered-js {
    td.complaint-actions-inline {
      background: #F1DDDE;

      &::before {
        background: linear-gradient(to right, rgba(241, 221, 222, 0), #F1DDDE 100%);
      }
    }
  }

  &.set td.complaint-actions-inline {
    background: #ececec;

    &::before {
      background: linear-gradient(to right, rgba(236, 236, 236, 0), #ececec 100%);
    }
  }
}

.price-column {
  display: flex;
  flex-direction: column;
}

.row {
  .options.drop {
    .open-dropdown-js,
    .close-dropdown-js,
    .delete-product-from-wishlist-js {
      opacity: 0;
    }
  }
  &:hover,
  &:focus-within,
  &.hovered-js {
    background: #F1DDDE;

    .quantity {
      background: #fff;
    }

    .options.drop {
      .open-dropdown-js,
      .close-dropdown-js,
      .delete-product-from-wishlist-js {
        opacity: 1;
      }
    }
  }

  &.set {
    background: #ececec;
    border-bottom: 1px solid #cdcdcd;
    border-width: 2px 0;

    &:hover {
      background: #F1DDDE;
    }
  }
}

.can-hover {
  cursor: pointer;
}

.no-hover {
  &:hover {
    background: none;
  }
}

.state {
  display: flex;
  align-items: center;
  min-width: max-content;
  gap: 8px;
}
.id {
  padding-left: 8px !important;
}
.product-cell {
  display: flex;
  flex-grow: 1;
  min-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;

  .image {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    fill: $labelsColor;
    display: flex;
    justify-content: center;

    img {
      object-fit: contain;
      border-radius: 4px;
    }
  }

  .product-info {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .product-name {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      color: $iconColors;
      max-width: 500px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .product-code,
    .description {
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
      color: #4A4A4A;
    }
  }
}

.no-data {
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.success-container {
  width: fit-content;
  background: $successColor;
  padding: 1px 8px;
  border-radius: 3px;
  color: $infoColor;
}

.paid {
  color: $successColor;
}

.warning-container {
  width: max-content;
  background: #{"{{settings.warningColor}}"};
  padding: 1px 8px;
  border-radius: 3px;
  color: $infoColor;
}

.partial {
  color: #{"{{settings.warningColor}}"};
}

.danger-container {
  width: fit-content;
  background: $dangerColor;
  padding: 1px 8px;
  border-radius: 3px;
  color: $infoColor;
}

.info-container {
  width: fit-content;
  background: #0a68ca;
  padding: 1px 8px;
  border-radius: 3px;
  color: $infoColor;
}

.not-paid {
  color: $dangerColor;
}

.erp-orders-tab {
  margin-bottom: 24px;

  .form__input-value {
    margin-left: 16px;
    width: 140px;
  }
}

.message-container {
  border-radius: 5px;
  border: 1px solid $secondaryBtnBorderColor;
  background: #F8F9FA;
  padding: 8px 16px;
  width: fit-content;
  margin: 24px 0;
}

.return-info-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin: 0 0 24px 0;
  background: #E8F1F8;
  border: 1px solid #C7DCEE;
  border-radius: 5px;
  font-size: 14px;
  line-height: 20px;
  color: #2C3E50;

  .icon {
    flex-shrink: 0;
    fill: #4A90BC;
  }

  strong {
    font-weight: 600;
  }
}

.default-address {
  width: fit-content;
  background: $successColor;
  border-radius: 2px;
  padding: 1px 8px;
}

.default {
  width: fit-content;
  background: $successColor;
  padding: 1px 8px;
  border-radius: 3px;
  color: $infoColor;
}

.toggle-button {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .text {
    margin-left: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  input[type="checkbox"] {
    visibility: hidden;
    display: none;
  }

  .toggle {
    position: relative;
    display: block;
    width: 40px;
    height: 20px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transform: translate3d(0, 0, 0);

    &:before {
      content: "";
      position: relative;
      top: 3px;
      left: 3px;
      width: 34px;
      height: 14px;
      display: block;
      background: #9a9999;
      border-radius: 8px;
      transition: background 0.2s ease;
    }

    span {
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      display: block;
      background: white;
      border-radius: 10px;
      box-shadow: 0 3px 8px rgba(154, 153, 153, 0.5);
      transition: all 0.2s ease;

      &:hover {
        background: #F1DDDE;
      }

      &:before {
        content: "";
        position: absolute;
        display: block;
        margin: -18px;
        width: 56px;
        height: 56px;
        background: #934346;
        border-radius: 50%;
        transform: scale(0);
        opacity: 1;
        pointer-events: none;
      }
    }
  }

  #cbx:checked + .toggle {
    &:before {
      background: #9a6f70;
    }

    span {
      background: #934346;
      transform: translateX(20px);
      transition: all 0.2s cubic-bezier(0.8, 0.4, 0.3, 1.25), background 0.15s ease;

      &:before {
        transform: scale(1);
        opacity: 0;
        transition: all 0.4s ease;
      }
    }
  }
}

.lock-pure {
  color: #DA2442;

  svg {
    fill: #DA2442;
  }

  &:hover {
    color: #ff95a7;

    svg {
      fill: #ff95a7;
    }
  }
}

.unlock-pure {
  color: #008945;

  svg {
    fill: #008945;
  }
  &:hover {
    color: #5cb186;

    svg {
      fill: #5cb186;
    }
  }
}

.lock {
  background: #DA2442;

  &:hover {
    background: #ff95a7;
  }
}

.options,
.dropdown-wrapper {
  position: relative;
  text-align: center !important;

  .dropdown {
    position: absolute;
    z-index: 999;
    background-color: white;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    width: max-content;
    max-width: 90vw;
    transition: visibility 0s linear 0.3s, opacity 0.3s ease;

    .pure-button {
      color: $primaryColorFont;
      display: flex;
      padding: 10px 16px;
      font-weight: 400;
      width: 100%;

      &:hover, &.focused-option-js {
        background: #F1DDDE;
      }

      &:first-child {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }
  
      &:last-child {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
  }

  .header-options {
    right: auto !important;
  }
}

.submenu {
  display: flex;
  gap: 8px;
}

.options-buttons {
  display: flex;
  gap: 16px;
}

.submenu-header {
  border-bottom: 1px solid #E7E7E7;
  padding-bottom: 16px !important;
}

.navigation-header {
  display: flex;
  gap: 24px;
}

.erp-name {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.details-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  padding: 24px 0;
  gap: 24px;

  &__state {
    display: flex;
    flex-direction: column;
  }

  .customer-info__content {
    margin: 0;
    min-width: auto;

    .title {
      display: block;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: $labelsColor;
    }
  }

  &__summary {
    display: flex;
    width: max-content;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 8px;

    .row-summ {
      display: grid;
      grid-template-columns: auto auto;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      gap: 16px;
      
      span {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }

      .title {
        display: block;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: $labelsColor;
      }
    }

    .summary {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      align-self: stretch;
      gap: 24px;
      font-size: 18px !important;
      font-weight: 600 !important;
      line-height: 24px !important;
    }
    
    .price {
      text-align: end;
    }

    &.discount-limit {
      min-width: 25%;
      align-items: flex-start;
    }
  }

  .details {
    gap: 37px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
  }
}

.attachements-container {
  padding-top: 8px;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  flex-direction: column;

  .title {
    display: block;
    font-weight: 400;
    color: $labelsColor;
  }

  .attachements {
    display: flex;
    align-items: center;
    gap: 24px;
    margin: 16px 0 32px;
    flex-wrap: wrap;
  
    a {
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
}

.waybills {
  padding-bottom: 16px;
}

.info-container-js {
  .pure-button {
    margin-bottom: 24px;
  }
}

.order-details {
  &__row {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    gap: 24px;
    padding-bottom: 24px;
  }

  &-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;

    .title {
      display: block;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: $labelsColor;
    }

    span {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      word-break: break-word;
    }
  }

  @media screen and (max-width: 1574px) {
    &__row {
      grid-template-columns: repeat(3, minmax(180px, 1fr));
    }
  }
}

.complaint-notice {
  padding-bottom: 24px;
}

.toggle-waybill-details {
  .show,
  .hide {
    text-align: left;
    display: flex;
    gap: 4px;
    margin: 16px 0;

    label {
      cursor: pointer;
    }
  }

  .toggle-waybills-checkbox {
    display: none;
    .label {
      color: inherit;
    }
  }

  .toggle-waybills-checkbox:checked ~ .waybill-details {
    max-height: 1100px;
  }

  .toggle-waybills-checkbox:checked ~ .show {
    display: none;
  }

  .toggle-waybills-checkbox:not(:checked) ~ .hide {
    display: none;
  }

  .waybill-details {
    max-height: 0;
    overflow: hidden;
    transition: max-height 1.0s ease;

    &__row {
      display: grid;
      grid-template-columns: repeat(4, minmax(150px, 1fr));
      gap: 24px;
      padding-bottom: 24px;

      &:last-child {
        padding-bottom: 0;
      }
    }

    &-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      width: 100%;

      .title {
        display: block;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: $labelsColor;
      }

      span {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      }
    }

    @media screen and (max-width: 1574px) {
      &__row {
        grid-template-columns: repeat(3, minmax(180px, 1fr));
      }
    }

    &.expanded {
      max-height: 1100px;
    }
  }
}

.not-expandable {
  padding-top: 24px;
  max-height: fit-content !important;
}

.related-erp {
  padding-top: 24px;
}

.product-container {
  display: flex;
  gap: 16px;

  .image {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    
    img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      object-fit: contain;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;

    .name {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      color: #934346;
    }

    .description {
      text-align: left;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
    }
  }
}

.amount-stepper-container {
  text-align: left;
  padding: 24px 0;
}

.add-complaint-form-js {
  .quantity__plus.disabled-js,
  .quantity__minus.disabled-js {
    opacity: 0.4;
  }
}

.add-complaint-form-js .data-form__header.return-success__header {
  margin-bottom: 8px;
}

.return-success {
  &__icon {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;

    svg {
      fill: #2E7D32;
    }
  }

  &__title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: $primaryColorFont;
    margin-bottom: 8px;
  }

  &__subtitle {
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: $labelsColor;
    padding-bottom: 24px;
    border-bottom: 1px solid #E7E7E7;
    margin-bottom: 24px;
  }

  &__email-box {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    background: #F0F6FC;
    border: 1px solid #D6E4F0;
    border-radius: 6px;
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 20px;
    color: $primaryColorFont;

    svg {
      fill: #1976D2;
      flex-shrink: 0;
      margin-top: 2px;
    }
  }

  &__steps-title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $primaryColorFont;
    margin-bottom: 12px;
  }

  &__steps {
    margin: 0 0 24px;
    padding-left: 20px;
    font-size: 14px;
    line-height: 20px;
    color: $primaryColorFont;

    li {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.file-attachements-wrapper {
  text-align: left;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: $iconColors;

  svg {
    fill: $iconColors;
  }

  .file {
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  .file-container {
    .file {
      align-items: center;
      font-weight: 400;
      color: $primaryColorFont;
      justify-content: flex-start;
    }

    .icon-js svg {
      fill: $primaryColorFont;
    }

    .clear-file-input-js {
      flex-shrink: 0;
      display: flex;
      align-items: center;

      svg {
        width: 14px;
        height: 14px;
        fill: $primaryColor;
      }
    }
  }
}

.hover-text {
  display: none;
}

.info-icon {
  width: 16px;
  height: 16px;
}

.info-icon:hover + .hover-text {
  display: inline;
  padding: 4px 8px;
  background: #4A4A4A;
  color: #FFFFFF;
  position: absolute;
  width: max-content;
  left: 110px;
  border-radius: 3px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.download-file {
  display: flex;
  gap: 8px;
  width: fit-content;
  align-items: center;
}
`